module.exports = __webpack_public_path__ + "img/rda.54fae865.jpg";